// LoadingSpinner.js
import React from 'react';
import '../css/LoadingSpinner.css'; // Import the CSS for the spinner

const LoadingSpinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingSpinner;